import * as React from "react";
import NewButton from "../uiMerge/newButton";
import { NewModal } from "../uiMerge/newModal";
import walletIcon from "../../assets/svg/walletNewIcon.svg";

type ComingSoonModalProps = {
  visible: boolean;
  onCancel: () => void;
  onOk: () => void;
};

export const ComingSoonModal: React.FC<ComingSoonModalProps> = ({
  visible,
  onCancel,
  onOk,
}) => {
  return (
    <NewModal
      isOpen={visible}
      colorClass="bg-[#1E1E1E]"
      roundedClass="rounded-2xl"
      widthClass="w-[350px]"
      showCloseButton={false}
      animationClass="grow-in"
      position="center"
      onClose={onCancel}
      onOk={onOk}
    >
      <div className="p-5 text-white flex flex-col min-h-[38vh] justify-center items-center">
        <div className="text-center w-[250px] gap-y-2 flex flex-col justify-center items-center">
          <div className="pb-4">
            <img src={walletIcon} alt="Wallet Icon" />
          </div>

          <div className="flex flex-col items-center space-y-2">
            <p className="text-2xl font-bold">Coming Soon!</p>
            <p className="text-md text-[#CECECF] font-normal">
              We're rolling out this feature soon, please stay tuned for
              updates.
            </p>
          </div>

          <div className="w-full pt-5 flex flex-col">
            <NewButton variant="outline" fullWidth onClick={onCancel}>
              Okay
            </NewButton>
          </div>
        </div>
      </div>
    </NewModal>
  );
};
